import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetEarmarkConversionListingReduxParams } from '~types/feat/gold';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchGetEarmarkConversionListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetEarmarkConversionListingAttempt', handleGetEarmarkConversionListing, api);
}
function* handleGetEarmarkConversionListing(api: GoldGateway, _data: PayloadAction<TGetEarmarkConversionListingReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const {
        index,
        filters: {
            customerName,
            idNo,
            branchName,
            dateTo,
            dateFrom,
        },
    } = reduxState.gold.earmarkConversionListing;

    const allBranches = reduxState.branch.allBranches;
    const selectedBranch = allBranches.find(branch => branch.branchName === branchName);

    const response = yield* call([api, api.getEarmarkConversionListing], {
        authToken,
        index,
        customerName: customerName || undefined,
        idNo: idNo || undefined,
        branchId: selectedBranch ? String(selectedBranch.branchId) : undefined,
        dateTo: dateTo || undefined,
        dateFrom: dateFrom || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetEarmarkConversionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetEarmarkConversionListingSuccess(response.data));
    }
}
